import { Stack, StackProps } from '@mui/material';

import { UploadedFile, UploadedFileListItem } from '../UploadedFileListItem/UploadedFileListItem';

export type FileLoadingStates = Record<string, boolean>;

export interface UploadedFileListProps extends StackProps {
  files?: UploadedFile[];
  fileLoadingStates?: FileLoadingStates;
  onDelete?: (file: UploadedFile) => void;
}

export const UploadedFileList = ({ files, fileLoadingStates, onDelete, children }: UploadedFileListProps) => {
  return (
    <>
      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        sx={{
          flex: 1,
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        {files?.map((file) => (
          <UploadedFileListItem
            key={file.fileId}
            fileId={file.fileId}
            isLoading={fileLoadingStates?.[file.fileId]}
            onDelete={onDelete}
          />
        ))}
        {children}
      </Stack>
    </>
  );
};
